import React from 'react';
import {createRoot} from 'react-dom/client';
import BaseComponent from '@components/base/BaseComponent/BaseComponent';
import styles from './PagePrivacyPolicy.scss';
import {ContextDataStore} from "@helpers/HelperGlobalDataStore";
import {ContextServicePriceProvider} from "@contexts/ContextServicePriceProvider";
import Header from "@components/base/Header/Header";

import '../../common/scss/blueprint-css/_blueprint.scss';
import CommonPageHeaderDataShort from "@components/base/Header/data/CommonPageHeaderDataShort";

class PagePrivacyPolicy extends BaseComponent {

	constructor() {
		super(...arguments, 'PagePrivacyPolicy');
		SHVO.pageComponent = this;
	}

	render() {
		const {
			mainNav,
			srcPrivacyPolicyPdf,
		} = this.state.componentData;
		return (
			<div>
				<ContextServicePriceProvider>
					<Header data={CommonPageHeaderDataShort}/>
				</ContextServicePriceProvider>
				<iframe id={styles.pdfIframe} src={srcPrivacyPolicyPdf} width={100} height={100}>
				</iframe>
			</div>
		);

	}
}


// React Context binding
PagePrivacyPolicy.contextType = ContextDataStore;
const container = document.getElementById(SHVO.pageAppId);
const root = createRoot(container);
root.render(<PagePrivacyPolicy data={SHVO.pageState} isLazy={1}/>);